import { DomSanitizer, SafeResourceUrl, SafeStyle, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnterpriseConfigurationDataAccessService } from '../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';

export abstract class AbstractHeader {
  public logoUrl$: Observable<SafeResourceUrl | null>;
  public logoAnchorUrl$: Observable<SafeUrl | null>;
  public siteName$: Observable<string>;
  public siteNameStyle$: Observable<SafeStyle | null>;
  public isNavBarCollapsed = true;
  public logoWidth$: Observable<number | undefined>;
  public logoHeight$: Observable<number | undefined>;
  public isMasterCardUser$: Observable<boolean>;

  protected constructor(
    private _enterpriseConfigurationService: EnterpriseConfigurationDataAccessService,
    private _sanitizer: DomSanitizer,
  ) {
    const enterpriseConfiguration$ = _enterpriseConfigurationService.getEnterpriseConfiguration();
    // We don't have any subscriptions other than in the HTML so we do not have to unsubscribe.
    this.logoUrl$ = enterpriseConfiguration$.pipe(
      map((config) => {
        if (config.logoUrl) {
          return this._sanitizer.bypassSecurityTrustResourceUrl(config.logoUrl);
        }
        return null;
      }),
    );
    this.logoAnchorUrl$ = enterpriseConfiguration$.pipe(
      map((config) => {
        if (config.logoAnchorUrl) {
          return this._sanitizer.bypassSecurityTrustUrl(config.logoAnchorUrl);
        }
        return null;
      }),
    );
    // Logo height and width are necessary in IE to size SVG images that have a viewport size
    this.logoHeight$ = enterpriseConfiguration$.pipe(map((config) => config.logoHeight));
    this.logoWidth$ = enterpriseConfiguration$.pipe(map((config) => config.logoWidth));
    this.isMasterCardUser$ = enterpriseConfiguration$.pipe(map((config) => config.isMasterCardUser));
    this.siteNameStyle$ = enterpriseConfiguration$.pipe(
      map((config) => {
        if (config.siteNameStyle) {
          return this._sanitizer.bypassSecurityTrustStyle(config.siteNameStyle);
        }
        return null;
      }),
    );
    this.siteName$ = enterpriseConfiguration$.pipe(map((config) => config.headerSiteNameHtml));
  }

  toggleNavBar(): void {
    this.isNavBarCollapsed = !this.isNavBarCollapsed;
  }
}
